module.exports = __webpack_public_path__ + "img/sort_both.png?a976d3b565a52b11fdc35c188a147b57";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/img/icons/sort_both.png
// module id = 279
// module chunks = 0